import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";
import { markMoveInCashUnavailableModalSeen } from "../../../Utils/helpers";

import { CircleExclamation } from "../../../Assets/Icons";

export default function renderMoveInCashUnavailable(modalContext) {
  const { updateModalComponent, updateModalOnCloseCallBack, setModalVariant, setModalTitle, setModalClassName, setModalAriaLabel } = modalContext;

  updateModalComponent(() => <MoveInCashUnavailable />);
  updateModalOnCloseCallBack(markMoveInCashUnavailableModalSeen);
  setModalVariant(modalVariants.statusDialog);
  setModalTitle("");
  setModalAriaLabel?.("Move-In Cash isn't available");
  setModalClassName("");
}

const MoveInCashUnavailable = () => {
  const { onModalClose } = useModalContext();

  const handleGotIt = () => {
    onModalClose();
  };

  return (
    <>
      <div className="modal-dialog-content">
        <CircleExclamation className="modal-status-icon alert-error mb-4" />
        <h3 className="modal-status-title mt-5 mb-2">Move-In Cash isn't available for your lease.</h3>
        <span className="modal-content-text">
          Cash back is available within 30 days of your lease start date. You can still request a legacy check through
          Customer Care, or open a Stake Checking account.
        </span>
      </div>
      <div className="action-container split-equally">
        <PrimaryButton onClick={handleGotIt}>Got it</PrimaryButton>
      </div>
    </>
  );
};
